module.exports = __webpack_public_path__ + "media/svg/patch-question-539d3483.svg";